/**
 * Descargar imagen o video desde una url
 * @param srcUrl
 * @param fileType
 * @return {Promise<void>}
 * @constructor
 */
export const DownloadImgFromUrl = async (srcUrl, fileType) => {
    let extension = fileType === 'img' ? '.jpg' : '.mp4';
    if (extension === '.mp4') {
        srcUrl = 'https://nodeapi.tueducaciondigital.site/download?url=' + encodeURIComponent(srcUrl)
    }
    let response = await fetch(srcUrl)
    const blob = await response.blob()
    let url = "";
    if (extension === '.mp4') {
        const mimeType = response.headers.get('content-type') || 'application/octet-stream'
        const base64String = await blobToBase64(blob)
        url = `data:${mimeType};base64,${base64String}`
    } else {
        url = window.URL.createObjectURL(new Blob([blob]));
    }
    const link = document.createElement("a");
    link.href = url;
    link.download = Date.now() + extension;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}
/**
 * Encodear un recurso
 * @param blob
 * @return {Promise<unknown>}
 */
const blobToBase64 = async (blob) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onloadend = () => {
            const base64String = reader.result
            resolve(base64String.split(',')[1])
        }
        reader.onerror = reject
    })
}